module.exports = __webpack_public_path__ + "img/BedroomofmonkaS.039df192.png";